import type { SortCondition, SortOrder } from './types';

const isSortOrder = (value: string): value is SortOrder => value === 'asc' || value === 'desc';

/**
 * URL search params の並列配列（sort カラム名 / sort 順）から SortCondition[] を組み立てる。
 * 配列長の不一致や未知値はスキップして安全側に倒す（仮実装の URL 共有時の堅牢性のため）。
 */
export const parseSortConditions = <ColumnId extends string>({
  sortBy,
  sortOrder,
  isColumnId,
}: {
  sortBy: readonly string[] | undefined;
  sortOrder: readonly string[] | undefined;
  isColumnId: (value: string) => value is ColumnId;
}): SortCondition<ColumnId>[] => {
  if (!sortBy || !sortOrder) return [];
  const len = Math.min(sortBy.length, sortOrder.length);
  const result: SortCondition<ColumnId>[] = [];
  for (let i = 0; i < len; i++) {
    const col = sortBy[i];
    const order = sortOrder[i];
    if (col === undefined || order === undefined) continue;
    if (!isColumnId(col)) continue;
    if (!isSortOrder(order)) continue;
    result.push({ columnId: col, order });
  }
  return result;
};
